import { nativeResponseRequest } from "@smartling/requester";
import { RegisterAccountAnswer, RegistrationFormType } from "../types";

export function registerAccount(
    productUid: string,
    form: RegistrationFormType,
    token: string,
    hasDeveloperSandbox: boolean,
    hsCtaAttrib: string
): Promise<RegisterAccountAnswer> {
    const [firstName, ...lastNameArray] = form.accountName.split(" ");
    const lastName = lastNameArray.join(" ");
    const accountName = hasDeveloperSandbox ? form.companyName : form.accountName;

    return nativeResponseRequest({
        method: "POST",
        url: `/account-registration/products/${productUid}/create-account`,
        body: JSON.stringify({
            productUid,
            account: {
                accountName
            },
            user: {
                firstName,
                lastName,
                email: form.email,
                password: form.password,
                confirmPassword: form.confirmPassword,
                jobTitle: hasDeveloperSandbox ? form.jobTitle.trim() : undefined,
                phone: "",
                sendUpdates: false
            },
            protectedAccountRegistrationPassword: "",
            recaptchaResponseToken: token,
            hsCtaAttrib: hsCtaAttrib || undefined
        })
    }).then(data => data.json());
}
